import { render } from "./SessionExpiry.vue?vue&type=template&id=77bc039f"
import script from "./SessionExpiry.vue?vue&type=script&lang=js"
export * from "./SessionExpiry.vue?vue&type=script&lang=js"

import "./SessionExpiry.vue?vue&type=style&index=0&id=77bc039f&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__